const css = `.YUKrPa__noUnderline:hover{text-decoration:none}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"noUnderline":"YUKrPa__noUnderline"};
